import * as React from 'react';
import type { ToastMessage } from 'primereact/toast';

export function SupportIdErrorDetail({ detail, supportId }: { detail: ToastMessage['detail']; supportId: string }) {
    const [copyState, setCopyState] = React.useState<'idle' | 'copying' | 'copied' | 'failed'>('idle');

    const copy = async () => {
        setCopyState('copying');
        try {
            if (!navigator.clipboard?.writeText) throw new Error('clipboard unavailable');
            await navigator.clipboard.writeText(supportId);
            setCopyState('copied');
        } catch {
            setCopyState('failed');
        }
    };

    return <div>
        <div>{detail}</div>
        <div style={{ userSelect: 'text', overflowWrap: 'anywhere', marginTop: '0.5rem' }}>Support ID: {supportId}</div>
        <button type="button" className="p-button p-component p-button-text p-button-sm" onClick={copy} disabled={copyState === 'copying'}
            aria-label="Копировать support ID" style={{ marginTop: '0.5rem' }}>
            Копировать support ID
        </button>
        <div role="status" aria-live="polite">
            {copyState === 'copied' && 'Скопировано'}
            {copyState === 'failed' && 'Не удалось скопировать. Выделите и скопируйте support ID вручную'}
        </div>
    </div>;
}
